<template>
  <div class="listContent">
    <a-form :form="form" class="headForm" labelAlign="left">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="客户">
            <a-input v-decorator="['customerName']" placeholder="输入客户名称" @pressEnter="getList"/>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="创建日期">
            <a-range-picker v-decorator="['createDate']"/>
          </a-form-item>
        </a-col>

        <a-col :span="6" class="submitBtnBox">
          <a-button type="primary" class="btnMar" @click="getList">
            查询
          </a-button>
          <a-button @click="resetFields">
            清空
          </a-button>
        </a-col>
      </a-row>
    </a-form>
    <div class="editBox">
      <template v-for="el in menuBtnList">
        <template v-if="el.code.indexOf('third') < 0">
          <a-button
            :key="el.id"
            :type="el.code === 'add' ? 'primary' : el.code === 'delete' ? 'danger' : ''"
            :ghost="el.code === 'delete'"
            :disabled="(isDelete && el.code === 'delete') || (isEdit && el.code === 'edit')"
            @click="clickFunc(el.path,el.code)"
          >
            {{el.name}}
          </a-button>
        </template>
      </template>
    </div>
    <a-table
      ref="listRef"
      row-key="id"
      :loading="loading"
      :columns="columns"
      :data-source="list"
      class="tableBox"
      :row-selection="rowSelection"
      :pagination="pagination"
      :scroll="{ y }"
      bordered
    >
      <template slot="x" slot-scope="text, record">
        <a @click="() => getMaterial(record)">原料维护</a>
      </template>
    </a-table>
    <add-customer :visible="addVisible" @close='closeFunc' :type='modalType' :rowData='rowData'/>
  </div>
</template>
<script>
import AddCustomer from './ModalConponents/AddCustomer.vue'
import moment from 'moment'
import api from './api'
export default {
  props: ['btnList'],
  components: {AddCustomer},
  data() {
    return {
      y: 500,
      factoryId: window.localStorage.getItem('factoryId'),
      form: this.$form.createForm(this),
      menuBtnList: [],
      loading: false,
      columns: [
        {
          title: "代码",
          dataIndex: "customerCode",
          width: 150,
          ellipsis: true,
        },
        {
          title: "客户名称",
          dataIndex: "customerName",
          width: 130,
          ellipsis: true,
        },
        {
          title: "描述",
          dataIndex: "customerDescribe",
          width: 120,
          ellipsis: true,
        },
        {
          title: "用户",
          dataIndex: "createUserName",
          width: 160,
          ellipsis: true,
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          width: 160,
          ellipsis: true,
        },
        // {
        //   title: "编辑时间",
        //   dataIndex: "updateTime",
        //   width: 160,
        //   ellipsis: true,
        // },
        {
          title: "操作",
          dataIndex: "x",
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: "x" },
        },
      ],
      pagination: {
        total:0,
        pageSize:20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      addVisible: false,
      editVisible: false,
      modalType: 'add',
      rowData: {}
    }
  },
  computed:{
    rowSelection(){
      return {
        onChange: (selectedRowKeys,selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          let arr = [...this.selectedRows, ...selectedRows]
          this.selectedRows = selectedRowKeys.map(i => {
            return arr.filter(item=>item.id === i)[0]
          })
        },
        selectedRowKeys: this.selectedRowKeys
      }
    },
    isDelete(){
      return this.selectedRowKeys.length === 0
    },
    isEdit(){
      return this.selectedRowKeys.length !== 1
    }
  },
  created(){
    this.dealBtnList(this.btnList)
    this.getList()
  },
  mounted() {
    this.y = this.$refs.listRef.$el.offsetHeight - 116
  },
  watch: {
    btnList: {       
      handler(val){
        this.dealBtnList(val)
      },
      deep: true
    }
  },
  methods: {
    clickFunc(functionName,type){
      this[functionName](type)
    },
    addRow(){
      this.modalType = 'add'
      this.addVisible = true
    },
    editRow(){
      this.modalType = 'edit'
      this.rowData = this.selectedRows[0] || {}
      // this.editVisible = true
      this.addVisible = true
    },
    closeFunc(feild,type){
      if(type) {
        this.selectedRowKeys = []
        this.selectedRows = []
        this.getList()
      }
      this[feild] = false
    },
    deleteRow(){
      this.$confirm({
        title: '提示',
        content: '确认将选中的客户删除吗？',
        cancelText:'取消',
        okText:'确定',
        onOk: async () => {
          let ids = this.selectedRowKeys.join(',')
          let res = await api.deleteCustomerRow(ids)
          let {success,msg} = res || {}
          this.$message[success ? 'success' : 'warning'](msg)
          this.selectedRowKeys = []
          this.selectedRows = []
          this.getList({current: 1,pageSize: this.pagination.pageSize})
        },
      })
    },
    dealBtnList(val=[]){
      let menuObj = val.filter(e => e.code === "customer-management")[0] || {}
        if(menuObj && menuObj.children && menuObj.children.length){
          this.menuBtnList = menuObj.children || []
        }else{
          this.menuBtnList = []
        }
    },
    async getList(pagination) {
      const valid = await this.form.validateFields()
      this.loading = true
      let { current = 1, pageSize = 20 } = pagination || this.pagination
      let { createDate,...newdata } = valid
      let params = {
        factoryId: this.factoryId,
        startDate: createDate && createDate.length > 0 ? moment(createDate[0]).format('YYYY-MM-DD 00:00:00') : undefined,
        endDate: createDate && createDate.length > 0 ? moment(createDate[1]).format('YYYY-MM-DD 23:59:59') : undefined,
        ...newdata,
        current,
        size: pageSize
      }
      let res = await api.getCustomerList(params)
      let { success, data } = res
      if (success) {
        let { records = [], current = 1, total = 0, size = 10 } = data
        this.loading = false
        this.list = records
        this.pagination.current = current
        this.pagination.total = total
        this.pagination.pageSize = size
      }
    },
    resetFields(){
      this.form.resetFields()
    },
    getMaterial(record){
      window.localStorage.setItem('thirdBreadName',record.customerName)
      this.$router.push(`/mainPage/customer-material?name=${record.customerName}&id=${record.id}`)
    },
  }
}
</script>

<style lang="scss" scoped>
.listContent {
  .tableBox {
    height: calc(100% - 132px);
    min-height: 240px;
  }
}
</style>
